export function camelCase(name) {
  return name.charAt(0).toUpperCase() + name.slice(1).replace(/-(\w)/g, function (m, n) {
    return n.toUpperCase();
  });
}
export function lineSplit(name) {
  return name.replace(/[A-Z]/g, function (m, n) {
    return '-' + m.toLowerCase();
  });
}
export function isEmpty(value) {
  return typeof value === 'undefined' || value === null || value === '';
}
export function isChinese(str) {
  var pattern = new RegExp("[\u4E00-\u9FA5]+");

  if (pattern.test(str)) {
    return true;
  }

  return false;
}
//# sourceMappingURL=stringUtils.js.map
